import { ChangeDetectorRef, Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { OdataService } from 'src/app/shared/services/odata.service';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-auto-recon-map-item-select',
  templateUrl: './auto-recon-map-item-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutoReconMapItemSelectComponent),
      multi: true
    }
  ],
  styleUrls: ['./auto-recon-map-item-select.component.less']
})
export class AutoReconMapItemSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  @Input() amount: number = 0;
  @Input() isDebit: boolean = true;
  @Input() bankAccountId: any;
  @Input() date: string = '';

  searchColumns = ['docCode', 'description', 'referenceNo'];
  amountColumns = ['debit', 'credit', 'debitLocal', 'creditLocal'];

  getUrl(searchValue: string): string {
    let amountFilter = this.isDebit
      ? `Debit eq ${this.amount}`
      : `Credit eq ${this.amount}`;

    let filter = `ClearedDate eq null and BankAccountId eq ${this.bankAccountId}`;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      const searchFilters = this.odata.getSearchFilters(
        searchStr,
        this.searchColumns,
        this.amountColumns
      );

      if (searchFilters.length) {
        filter = `${filter} and (${searchFilters
          .map(x => `(${x})`)
          .join(' or ')})`;
      }
    }

    let url = `api/BankReconciliationStatements/QueryAutoMapItems?$expand=currency($select=code)&$orderby=docCode desc`;
    if (filter) url += `&$filter=${filter}`;
    url += `&isDebit=${this.isDebit}&amount=${this.amount}&bankAccountId=${this.bankAccountId}&date=${this.date}`;
    return url;
  }
}
